import axios from "axios";

const Planning = (state = [], action) => {
    switch (action.type) {
        case 'REQUEST_GET' :
            return axios.get('http://localhost:3000/Request')
                .then(function (res) {
                    return state = res.data;
                }.bind(this))

        case 'SET_PLANNING' :
            state = action.payload;
            return state;

        case 'PLANNING_SET_CARRY_SCORE'  :
            state.carryScoreList = action.payload;
            return state;
        default:
            return state;
    }
};
export default Planning;
